// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2fIVa","header":"MessagesList_header__2pYam","chat":"MessagesList_chat__2WnRF"};